import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Длинный текст игрока: биография, характер, описание вещи.
 *
 * Переносы сохраняются как есть (pre-wrap): двойной перенос игрок ставит
 * осознанно, и схлопывать его значит править чужой текст. Одно длинное слово
 * ломается, а не распирает экран горизонтальной прокруткой.
 */
export function Prose({ children }: { children: ReactNode }) {
  return <div className={styles.prose}>{children}</div>;
}

/**
 * Ряд «миниатюра слева, колонка текста справа».
 *
 * Выносится наружу, потому что в него упирается каждый список: тот же приём
 * внутри PropertyCard был заперт и его переписывали вкуишным Flex.
 *
 * Выравнивание по верху, а не по центру: колонка текста бывает в три строки,
 * и при центрировании миниатюра уезжала бы от заголовка.
 */
export function Media({
  aside,
  after,
  children,
}: {
  aside: ReactNode;
  /** Хвост справа: стрелка у строки, которая куда-то ведёт. */
  after?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={styles.media}>
      {aside}
      <div className={styles.mediaBody}>{children}</div>
      {after === undefined ? null : <span className={styles.mediaAfter}>{after}</span>}
    </div>
  );
}
